import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgFavorite = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "-348.44 -348.44 2488.89 2488.89",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		transform: "matrix(1 0 0 -1 0 1536)",
		d: "M852 -110 228 492Q218 500 200.5 518.0Q183 536 145.0 583.5Q107 631 77.0 681.0Q47 731 23.5 802.0Q0 873 0 940Q0 1160 127.0 1284.0Q254 1408 478 1408Q540 1408 604.5 1386.5Q669 1365 724.5 1328.5Q780 1292 820.0 1260.0Q860 1228 896 1192Q932 1228 972.0 1260.0Q1012 1292 1067.5 1328.5Q1123 1365 1187.5 1386.5Q1252 1408 1314 1408Q1538 1408 1665.0 1284.0Q1792 1160 1792 940Q1792 719 1563 490L940 -110Q922 -128 896.0 -128.0Q870 -128 852 -110Z"
	})
});
export default SvgFavorite;
